const isExternalUrl = (url) => {
  let https = 'https://';
  let http = 'https://';
  if ( url.includes(http) || url.includes(https) ) {
    return true;
  } else {
    return false;
  }
}

export default isExternalUrl;